<template>
  <div class="brain-modal-input-group">
    <label for="" class="brain-modal-input-group__label">{{ name }}:</label>
    <input :value="value" type="text" class="w-full form-control form-input form-input-bordered" @input="onInput" />
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    value: String,
  },
  model: {
    prop: 'value',
    event: 'update',
  },
  methods: {
    onInput(event) {
      this.$emit('update', event.target.value);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../sass/web/_variables.scss';

.brain-modal-input-group {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-template-rows: 1fr;
  padding: 5px 0;
  &__label {
    color: #43454b;
    align-self: center;
    justify-self: left;
  }
}
</style>
